import { Box } from 'reflexbox';
import styled from 'styled-components';

import { AddIcon } from '../icons';
import { tokens } from '../theme/tokens';
import { Button } from './button/Button';

const Container = styled(Box)`
	display: flex;
	justify-content: center;
	align-items: center;
	box-sizing: border-box;
	width: 100%;
	padding: ${tokens.padding.section}px;
	border: 1px dashed ${tokens.border.default};
	border-radius: ${tokens.radius.md}px;
	background: transparent;
`;

export function PlaceholderButton(props: {
	title: string;
	onClick?: () => void;
	to?: string;
	type?: 'primary' | 'secondary';
}) {
	return (
		<Container>
			<Button
				type={props.type ?? 'primary'}
				icon={<AddIcon />}
				title={props.title}
				onClick={props.onClick}
				link={props.to ?? undefined}
			/>
		</Container>
	);
}
